const Constants = {
  // on prod the nginx gets req on /bayun
  baseURL: "https://bayun.dev/bayun",
  // baseURL: "http://localhost:8080/",
};

export default Constants;
